import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { pipelineStageDisplayLabels } from 'Integrations/index'

/**
 * Resolves the human-readable labels of the HubSpot pipeline stages configured
 * as import-eligible, so copy can name the actual stages the user set rather
 * than assume a fixed one. A deal must reach one of these stages for its company
 * to become an importable customer.
 */
export const useHubspotImportStages = (options?: { enabled?: boolean }) => {
  const query = useQuery(dashboard20240730Client.getIntegration, 'HubSpot', {
    enabled: options?.enabled ?? true,
    select: data => {
      if (!data || !('pipelineStages' in data)) {
        return []
      }
      const labelByStageId = pipelineStageDisplayLabels(data.pipelineStages)
      return (data.settings?.customerImportStages ?? []).map(
        stageId => labelByStageId.get(stageId) ?? stageId
      )
    }
  })

  return {
    stageLabels: query.data ?? [],
    isLoading: query.isLoading
  }
}
